import { createCacheWrapper } from '@utils/cache';
import { DAYS_TO_MS, HOURS_TO_MS } from '@utils/constants';
import { sitecoreAxios } from './core.axios.js';
import { mapResponseToPageDescriptor } from './request.get-page-descriptor.js';
import { buildUrl } from './util.build-url.js';

const cache = createCacheWrapper({
  timeToLiveMs: 1 * HOURS_TO_MS,
  evictAfterMs: 1 * DAYS_TO_MS,
  capacity: 1e4
});
function getNestedPages(portalConfig, pageId, options) {
  const levels = (options == null ? void 0 : options.levels) ?? 1;
  return cache(
    !(options == null ? void 0 : options.disableCache) ? `${portalConfig.id}-${pageId}-${levels}-${!!(options == null ? void 0 : options.previewMode)}` : void 0,
    async () => {
      const pageDescriptors = await fetchNestedPages(portalConfig, pageId, {
        ...options,
        levels
      });
      if (pageId === void 0) {
        const homePageDescriptor = pageDescriptors.find(
          (it) => it.path === "/"
        );
        if (homePageDescriptor && homePageDescriptor.hasChildren && !homePageDescriptor.children) {
          homePageDescriptor.children = await fetchNestedPages(
            portalConfig,
            homePageDescriptor.id,
            {
              ...options,
              levels: 1
            }
          );
        }
      }
      return pageDescriptors;
    }
  ).getStaleWhileRevalidate();
}
async function fetchNestedPages(portalConfig, pageId, options) {
  const url = buildUrl(
    `/api/v1/portals/${portalConfig.id}/items/${pageId ?? portalConfig.id}/navigation?levels=${options.levels}`,
    options
  );
  const response = await sitecoreAxios.get(url);
  return response.data.map((it) => mapResponseToPageDescriptor(portalConfig.homePath, it, pageId)).filter((it) => it !== void 0);
}

export { getNestedPages };
//# sourceMappingURL=request.get-nested-pages.js.map
